import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { checkIndexOverflow3frtmheghr0th as checkIndexOverflow } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { NativeContainerElement390em0tm6yzca as NativeContainerElement } from '../NativeContainerElement.commonHtml.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      internalAddChildStack_5el07d_k$(on, index, element) {
        var elementNative = element.get_underlyingNativeElement_vngz33_k$().native_1;
        if (index === 0) {
          // Inline function 'com.lightningkite.kiteui.views.display' call
          on.native_1.style_1.native_1.display = 'flex';
        } else if (index >= 1) {
          // Inline function 'com.lightningkite.kiteui.views.display' call
          var tmp = on.native_1.style_1.native_1.display;
          if (!(((!(tmp == null) ? typeof tmp === 'string' : false) ? tmp : null) === 'grid')) {
            // Inline function 'com.lightningkite.kiteui.views.display' call
            on.native_1.style_1.native_1.display = 'grid';
            on.native_1.setStyleProperty_wavvb3_k$('grid-template-columns', '100%');
            on.native_1.setStyleProperty_wavvb3_k$('grid-template-rows', '100%');
          }
        }
        // Inline function 'kotlin.collections.forEachIndexed' call
        var index_0 = 0;
        var _iterator__ex2g4s = on.native_1.get_children_4cwbp4_k$().iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var item = _iterator__ex2g4s.next_20eer_k$();
          var _unary__edvuaz = index_0;
          index_0 = _unary__edvuaz + 1 | 0;
          var index_1 = checkIndexOverflow(_unary__edvuaz);
          var tmp0 = item.style_1;
          // Inline function 'com.lightningkite.kiteui.views.zIndex' call
          var value = index_1.toString();
          tmp0.native_1.zIndex = value;
        }
        elementNative.setStyleProperty_wavvb3_k$('grid-area', '1 / 1 / 1 / 1');
        var tmp0_subject = elementNative.desiredVerticalGravity_1;
        switch (tmp0_subject == null ? -1 : tmp0_subject.ordinal_1) {
          case 0:
            // Inline function 'com.lightningkite.kiteui.views.verticalAlign' call

            elementNative.style_1.native_1.verticalAlign = 'top';
            // Inline function 'com.lightningkite.kiteui.views.alignSelf' call

            elementNative.style_1.native_1.alignSelf = 'start';
            break;
          case 1:
            // Inline function 'com.lightningkite.kiteui.views.display' call

            var tmp_0 = on.native_1.style_1.native_1.display;
            if (!(((!(tmp_0 == null) ? typeof tmp_0 === 'string' : false) ? tmp_0 : null) === 'grid')) {
              // Inline function 'com.lightningkite.kiteui.views.display' call
              on.native_1.style_1.native_1.display = 'grid';
              on.native_1.setStyleProperty_wavvb3_k$('grid-template-columns', '100%');
              on.native_1.setStyleProperty_wavvb3_k$('grid-template-rows', '100%');
            }

            // Inline function 'com.lightningkite.kiteui.views.alignSelf' call

            elementNative.style_1.native_1.alignSelf = 'center';
            break;
          case 2:
            // Inline function 'com.lightningkite.kiteui.views.verticalAlign' call

            elementNative.style_1.native_1.verticalAlign = 'bottom';
            // Inline function 'com.lightningkite.kiteui.views.alignSelf' call

            elementNative.style_1.native_1.alignSelf = 'end';
            break;
          default:
            // Inline function 'com.lightningkite.kiteui.views.verticalAlign' call

            elementNative.style_1.native_1.verticalAlign = 'top';
            // Inline function 'com.lightningkite.kiteui.views.height' call

            var tmp_1 = elementNative.style_1.native_1.height;
            // Inline function 'kotlin.text.isNullOrEmpty' call

            var this_0 = (!(tmp_1 == null) ? typeof tmp_1 === 'string' : false) ? tmp_1 : null;
            if (this_0 == null || charSequenceLength(this_0) === 0) {
              // Inline function 'com.lightningkite.kiteui.views.height' call
              elementNative.style_1.native_1.height = '100%';
            }

            // Inline function 'com.lightningkite.kiteui.views.alignSelf' call

            elementNative.style_1.native_1.alignSelf = 'stretch';
            break;
        }
        var tmp1_subject = elementNative.desiredHorizontalGravity_1;
        switch (tmp1_subject == null ? -1 : tmp1_subject.ordinal_1) {
          case 0:
            // Inline function 'com.lightningkite.kiteui.views.marginLeft' call

            elementNative.style_1.native_1.marginLeft = 'unset';
            // Inline function 'com.lightningkite.kiteui.views.marginRight' call

            elementNative.style_1.native_1.marginRight = 'auto';
            // Inline function 'com.lightningkite.kiteui.views.justifySelf' call

            elementNative.style_1.native_1.justifySelf = 'start';
            break;
          case 1:
            // Inline function 'com.lightningkite.kiteui.views.marginLeft' call

            elementNative.style_1.native_1.marginLeft = 'auto';
            // Inline function 'com.lightningkite.kiteui.views.marginRight' call

            elementNative.style_1.native_1.marginRight = 'auto';
            // Inline function 'com.lightningkite.kiteui.views.justifySelf' call

            elementNative.style_1.native_1.justifySelf = 'center';
            break;
          case 2:
            // Inline function 'com.lightningkite.kiteui.views.marginLeft' call

            elementNative.style_1.native_1.marginLeft = 'auto';
            // Inline function 'com.lightningkite.kiteui.views.marginRight' call

            elementNative.style_1.native_1.marginRight = 'unset';
            // Inline function 'com.lightningkite.kiteui.views.justifySelf' call

            elementNative.style_1.native_1.justifySelf = 'end';
            break;
          default:
            // Inline function 'com.lightningkite.kiteui.views.width' call

            var tmp_2 = elementNative.style_1.native_1.width;
            // Inline function 'kotlin.text.isNullOrEmpty' call

            var this_1 = (!(tmp_2 == null) ? typeof tmp_2 === 'string' : false) ? tmp_2 : null;
            if (this_1 == null || charSequenceLength(this_1) === 0) {
              // Inline function 'com.lightningkite.kiteui.views.width' call
              elementNative.style_1.native_1.width = '100%';
            }

            // Inline function 'com.lightningkite.kiteui.views.justifySelf' call

            elementNative.style_1.native_1.justifySelf = 'stretch';
            break;
        }
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var FrameClass;
function Frame() {
  if (FrameClass === VOID) {
    class $ extends NativeContainerElement() {
      constructor(context) {
        super(context);
        this.native_1.tag_1 = 'div';
        var tmp0 = this.native_1.style_1;
        // Inline function 'com.lightningkite.kiteui.views.lineHeight' call
        var value = '0px !important';
        tmp0.native_1.lineHeight = value;
      }
      nativeAddChild_hge4nv_k$(index, element) {
        super.nativeAddChild_hge4nv_k$(index, element);
        Companion_instance.internalAddChildStack_5el07d_k$(this, index, element);
      }
    }
    initMetadataForClass($, 'Frame');
    FrameClass = $;
  }
  return FrameClass;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  Frame as Frame1e7t2kcdb3wu7,
  Companion_instance as Companion_instance3sky7m0l0l4tp,
};
//endregion

//# sourceMappingURL=Frame.commonHtml.mjs.map
